import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";

interface CreateContextType {
  showCreateStaff: boolean;
  setShowCreateStaff: Dispatch<SetStateAction<boolean>>;

  showCreateHub: boolean;
  setShowCreateHub: Dispatch<SetStateAction<boolean>>;

  showCreateVehicle: boolean;
  setShowCreateVehicle: Dispatch<SetStateAction<boolean>>;

  showCreateRental: boolean;
  setShowCreateRental: Dispatch<SetStateAction<boolean>>;

  showCreateBooking: boolean;
  setShowCreateBooking: Dispatch<SetStateAction<boolean>>;

  showCreateSupport: boolean;
  setShowCreateSupport: Dispatch<SetStateAction<boolean>>;

  showBulkUploadVehicle: boolean;
  setShowBulkUploadVehicle: Dispatch<SetStateAction<boolean>>;
}

interface CreateProviderProps {
  children: ReactNode;
}

const CreateContext = createContext<CreateContextType | undefined>(undefined);

export const useCreateContext = (): CreateContextType => {
  const context = useContext(CreateContext);
  if (!context) {
    throw new Error("useCreateContext must be used within a CreateProvider");
  }
  return context;
};

export const CreateProvider: React.FC<CreateProviderProps> = ({ children }) => {
  const [showCreateStaff, setShowCreateStaff] = useState(false);
  const [showCreateHub, setShowCreateHub] = useState(false);
  const [showCreateVehicle, setShowCreateVehicle] = useState(false);
  const [showCreateRental, setShowCreateRental] = useState(false);
  const [showCreateBooking, setShowCreateBooking] = useState(false);
  const [showCreateSupport, setShowCreateSupport] = useState(false);
  const [showBulkUploadVehicle, setShowBulkUploadVehicle] = useState(false);

  const value = useMemo(
    () => ({
      showCreateStaff,
      setShowCreateStaff,

      showCreateHub,
      setShowCreateHub,

      showCreateVehicle,
      setShowCreateVehicle,

      showCreateRental,
      setShowCreateRental,

      showCreateBooking,
      setShowCreateBooking,

      showCreateSupport,
      setShowCreateSupport,

      showBulkUploadVehicle,
      setShowBulkUploadVehicle,
    }),
    [
      showCreateStaff,
      showCreateHub,
      showCreateVehicle,
      showCreateRental,
      showCreateBooking,
      showCreateSupport,
      showBulkUploadVehicle,
    ]
  );

  return (
    <CreateContext.Provider value={value}>{children}</CreateContext.Provider>
  );
};
